import type { CourseModule } from "@/core/types";
import { lektionAbschnitte } from "./lektion-01-abschnitte";
import { lektionNavigation } from "./lektion-02-navigation";
import { lektionGrosseDateien } from "./lektion-03-grosse-dateien";

export const modulAbschnitte: CourseModule = {
  id: "abschnitte",
  title: "Abschnitte und große Präsentationen",
  summary:
    "Ab zwanzig Folien braucht eine Präsentation Struktur: Abschnitte in der " +
    "Miniaturleiste, sichtbare Trennfolien, Foliennummern und eine Dateigröße, die sich " +
    "noch verschicken lässt.",
  level: "Aufbau",
  lessons: [lektionAbschnitte, lektionNavigation, lektionGrosseDateien],
};
